import React, { ReactNode } from 'react';
import { AlertDialogHeader } from '@chakra-ui/react';

interface Props {
  children: ReactNode;
}

export const AlertHeader = ({ children }: Props): JSX.Element => {
  return <AlertDialogHeader>{children}</AlertDialogHeader>;
};
export type { Props as AlertHeaderProps };
